<ion-item-sliding animate.enter="enter-animation">
  @if (!notification().readAt && !notification().deletedAt && enableSwipe()) {
    <ion-item-options side="start" (ionSwipe)="markAsRead.emit(notificationId())">
      <ion-item-option
        [expandable]="true"
        (click)="markAsRead.emit(notificationId())"
        class="read"
        color="primary"
        data-test="mark-as-read-option"
      >
        <fa-icon [icon]="faEnvelopeOpen" slot="top" />
        Gelezen
      </ion-item-option>
    </ion-item-options>
  }

  <ion-item
    lines="none"
    [class.unread]="!notification().readAt"
    [button]="!!notification().clickAction"
    (click)="onItemClick()"
    data-test="notification-item"
  >
    <div class="card" [class.isExpanded]="isExpanded">
      <div class="card-main">
        <div class="icon-container">
          <img [src]="notification().imageUrl ?? '/assets/logo.svg'" alt="Notificatie afzender" />
        </div>

        <div class="card-content">
          <div class="card-header">
            <h3>{{ notification().title }}</h3>

            <div slot="end">
              @if (sendAtToday()) {
                <span>{{ notification().sendAt | ttDate: { format: 'HH:mm' } }}</span>
              } @else if (sendAtCurrentYear()) {
                <span>{{ notification().sendAt | ttDate: { format: 'd MMM YYYY' } }}</span>
              } @else {
                <span>{{ notification().sendAt | ttDate: { format: 'dd-MM-yyyy' } }}</span>
              }
              @if (showCloseButton()) {
                <ion-button fill="clear" size="small" (click)="closing.emit()">
                  <fa-icon [icon]="faXmark" slot="icon-only" />
                </ion-button>
              }
            </div>
          </div>

          <div class="body">
            <p [class.line-clamp]="!isExpanded" #bodyText>{{ notification().body }}</p>

            @if (canExpand()) {
              <ion-button
                fill="clear"
                size="small"
                class="expand-button"
                data-test="notification-expand-button"
                (click)="toggleExpand($event)"
              >
                <fa-icon [icon]="isExpanded ? faChevronUp : faChevronDown" slot="icon-only" />
              </ion-button>
            }
          </div>
        </div>
      </div>

      @if (notification().actions.length > 0 && isExpanded) {
        <div class="expanded" data-test="expanded-content">
          @for (action of notification().actions; track action['@id'] ?? action.title) {
            <ion-button fill="clear" size="small" (click)="actionTriggered.emit(action)">{{
              action.title
            }}</ion-button>
          }
        </div>
      }
    </div>
  </ion-item>

  @if (!notification().deletedAt && enableSwipe()) {
    <ion-item-options side="end" (ionSwipe)="remove.emit(notificationId())">
      <ion-item-option
        [expandable]="true"
        (click)="remove.emit(notificationId())"
        class="delete"
        color="danger"
        data-test="delete-option"
      >
        <fa-icon [icon]="faTrashCan" slot="top" />
        Verwijderen
      </ion-item-option>
    </ion-item-options>
  }
</ion-item-sliding>
